import { render, staticRenderFns } from "./AcordosHome.vue?vue&type=template&id=0e9231c8"
import script from "./AcordosHome.vue?vue&type=script&lang=js"
export * from "./AcordosHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports